module.exports = __webpack_public_path__ + "static/media/szerzodesek_meglevo.3c894409.jpg";